import { DocumentClassKey } from '../document-classes/document-classes';
import { BehandlerAssignmentData } from '@ps-gui/shared-document-preview';

export const BatchDomain = {
  PROOF: 'PROOF',
} as const;

export type BatchDomain = (typeof BatchDomain)[keyof typeof BatchDomain];

export type CtBatch = ProofCtBatch | EingangCtBatch | TaskCtBatch;

export interface MetaDataSachbearbeiter {
  vorname?: string;
  nachname?: string;
  email?: string;
}

export interface MetaDataBetroffenePerson {
  vorname?: string;
  nachname?: string;
  geburtsdatum?: string;
}

export interface CtBatchMetaData {
  schadenNummer?: string;
  schadenDatum?: string;
  externeId?: string;
  tenant?: string;
  tenants: MandantKeyDisplayname[];
  initialeNachricht?: string;
  auftragstyp?: string;
  sachbearbeiter?: MetaDataSachbearbeiter;
  betroffenePerson?: MetaDataBetroffenePerson;
}

export interface MandantKeyDisplayname {
  uniqueKey: string;
  name: string;
  uniqueKeyAltsystem: string;
}

export interface CtBatchBase {
  id: string;
  documents: CtDocument[];
  state: CtBatchState;
  source: CtBatchSource;
  timestamp: Date;
  tenant: string;
  domain: BatchDomain;
  batchType: BatchType;
  metaData?: CtBatchMetaData;
}

export enum BatchType {
  PROOF = 'PROOF',
  EINGANG = 'EINGANG',
  TASK = 'TASK',
}

export enum EingangTyp {
  EMAIL = 'EMAIL',
  WEB_ORDER = 'WEB_ORDER',
  GDV = 'GDV',
  KUSS = 'KUSS',
  WEB_AKTE = 'WEB_AKTE',
}

export interface ProofCtBatch extends CtBatchBase {
  auditId: string;
  auditRequestId: string;
  claimNumber: string;
  proofType: string;
  orderDescription: string | undefined;
  businessTransaction: string;
  batchType: BatchType.PROOF;
  receivedAfterSubmission: boolean;
}

export interface EingangCtBatch extends CtBatchBase {
  eingangId: string;
  type: EingangTyp;
  batchType: BatchType.EINGANG;
}

export interface TaskCtBatch extends CtBatchBase {
  taskId: string;
  batchType: BatchType.TASK;
}

export function isProofCtBatch(batch: CtBatch): batch is ProofCtBatch {
  return batch.batchType === BatchType.PROOF;
}

export function isEingangCtBatch(batch: CtBatch): batch is EingangCtBatch {
  return batch.batchType === BatchType.EINGANG;
}

export function isTaskCtBatch(batch: CtBatch): batch is TaskCtBatch {
  return batch.batchType === BatchType.TASK;
}

export function eingangIdOf(batch: CtBatch): string | undefined {
  return isEingangCtBatch(batch) ? batch.eingangId : undefined;
}

export type CtBatchUnion = ProofCtBatch;

export enum CtBatchState {
  SPLITTING = 'SPLITTING',
  CLASSIFYING = 'CLASSIFYING',
  IN_CT1 = 'IN_CT1',
  EXTRACTING = 'EXTRACTING',
  IN_CT2 = 'IN_CT2',
  DONE = 'DONE',
}

export enum CtBatchSource {
  LEGACY = 'LEGACY',
  NEW_BACKEND = 'NEW_BACKEND',
}

export interface CtDocument {
  id: string;
  documentClasses: DocumentClassKey[];
  pages: CtPage[];
  index: number;
  originalFileIndex: number;
  behandlerAssignmentData?: BehandlerAssignmentData;
}

export interface CtDocumentId {
  documentId: string;
}

export interface CtPage {
  id: string;
  index: number;
  documentId: string;
  isEmpty: boolean;
  canonicalPageId: string | undefined;
}

export interface CtBatchLock {
  userId: string;
  batchId: string;
  userName: string;
  displayName: string;
  timestamp: Date;
}
